import { useState } from "react";
import RolesTab from "../../components/access-control/RolesTab";
import PermissionsTab from "../../components/access-control/PermissionsTab";
import { hasPermission } from "../../utils/uiAccessControl";

export default function AccessControlPage() {
  const [activeTab, setActiveTab] = useState("roles");

  return (
    <div className="dashboard-content min-h-full space-y-2 text-gray-900 dark:text-gray-100">
      {/* TABS */}
      <div className="flex gap-4 border-b border-gray-200 dark:border-gray-800 mb-6">
        <button
          onClick={() => setActiveTab("roles")}
          className={`pb-2 font-semibold transition ${
            activeTab === "roles"
              ? "border-b-2 border-primary text-primary dark:text-primary"
              : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          }`}
        >
          Roles
        </button>

        {hasPermission("PERMISSION_VIEW") && (
          <button
            onClick={() => setActiveTab("permissions")}
            className={`pb-2 font-semibold transition ${
              activeTab === "permissions"
                ? "border-b-2 border-primary text-primary dark:text-primary"
                : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            }`}
          >
            Permissions
          </button>
        )}
      </div>

      {/* CONTENT */}
      {activeTab === "roles" && <RolesTab />}
      {hasPermission("PERMISSION_VIEW") &&
        activeTab === "permissions" && <PermissionsTab />}
    </div>
  );
}